const cast = (value, dataType) => {
  if (dataType === 'number') {
    return Number(value);
  }
  return value;
};

export const sortByProp =
  (prop, dir = 'asc', mapFn = (n) => n) =>
  (a, b) => {
    const props = Array.isArray(prop) ? prop : [prop];
    const dirs = Array.isArray(dir) ? dir : [dir];

    for (let i = 0; i < props.length; ++i) {
      const p = props[i];

      const key = typeof p === 'function' ? p : typeof p === 'object' ? p.key : p;
      const dataType = p?.type;

      let aVal = cast(typeof key === 'function' ? key(a) : mapFn(a[key]), dataType);
      let bVal = cast(typeof key === 'function' ? key(b) : mapFn(b[key]), dataType);

      if (aVal !== bVal) {
        if (aVal instanceof Date && bVal instanceof Date) {
          aVal = aVal.getTime();
          bVal = bVal.getTime();
        }

        const order = dirs[i] || 'asc';

        if (dataType === 'number' || (typeof aVal === 'number' && typeof bVal === 'number')) {
          return order === 'asc' ? aVal - bVal : bVal - aVal;
        }

        const comparison = String(aVal || '').localeCompare(String(bVal || ''));

        return order === 'asc' ? comparison : -comparison;
      }
    }
    return 0;
  };
